"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlanCardParser = exports.CharacteristicSpan = void 0;
var _react = _interopRequireDefault(require("react"));
var _services = require("../../../services");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("../../constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Styled components
 */

const CharacteristicSpan = _styledComponents.default.span`
  font-weight: ${props => props.bold ? 700 : 400};
`;

/**
 * Interfaces
 */
exports.CharacteristicSpan = CharacteristicSpan;
/**
 * Parser class for the plan card
 */

class PlanCardParser {
  // -----------------------Constructor -----------------------
  constructor(_ref) {
    let {
      recommendationCharacteristics,
      numPlans,
      plan,
      planIdWithDifferentHeader,
      isAdditionalPlan,
      showFullPlanName,
      minimumDiscount,
      planIndex
    } = _ref;
    // -----------------------Properties -----------------------
    this.plan = void 0;
    this.recommendationCharacteristics = void 0;
    this.numPlans = void 0;
    this.planIdWithDifferentHeader = void 0;
    this.isAdditionalPlan = void 0;
    this.showFullPlanName = void 0;
    this.minimumDiscount = void 0;
    this.planIndex = void 0;
    this.recommendationCharacteristics = recommendationCharacteristics;
    this.plan = plan;
    this.isAdditionalPlan = isAdditionalPlan;
    this.numPlans = !isAdditionalPlan ? numPlans + 1 : numPlans;
    this.planIdWithDifferentHeader = planIdWithDifferentHeader;
    this.showFullPlanName = showFullPlanName;
    this.minimumDiscount = minimumDiscount;
    this.planIndex = !isAdditionalPlan ? planIndex : 0;
  }

  // -----------------------Methods -----------------------

  get PlanCardHeaderProps() {
    return !this.isAdditionalPlan ? this.CardHeaderPropsWithData : this.CardHeaderPropsWithDefault;
  }
  get CardHeaderPropsWithData() {
    const mainPriceBeforeDiscount = this.getPriceByPriceType(_constants.PRICE_TYPES.RECURRING);
    const mainPriceAfterDiscount = this.getPriceByPriceType(_constants.PRICE_TYPES.COMMERCE_PRICE);
    const rightStackMainTextLarge = `${_services.locale.formatPrice(mainPriceAfterDiscount.priceValue)}`;
    const rightStackMainTextNormal = `/${_services.locale.localeString('Recommendation.month')}`;
    const rightStackBottomTextNormal = _services.locale.localeString('Recommendation.RightStackBottomTextTemplate', {
      amount: mainPriceAfterDiscount.durationAmount,
      unit: _services.locale.localeString('Recommendation.month'),
      price: _services.locale.formatPrice(mainPriceBeforeDiscount.priceValue),
      pluralUnit: _services.locale.localeString('Recommendation.Month')
    });
    const amount = Math.round(100 * (1 - mainPriceAfterDiscount.priceValue / mainPriceBeforeDiscount.priceValue));
    const isPlanWithDifferentHeader = this.planIdWithDifferentHeader.some(text => {
      var _this$plan;
      return text.includes((_this$plan = this.plan) === null || _this$plan === void 0 ? void 0 : _this$plan.productId.split('-')[0]);
    });
    return {
      leftStack: {
        topText: isPlanWithDifferentHeader ? _services.locale.localeString('Recommendation.OtherPlanName') : _services.locale.localeString('Recommendation.PlanName'),
        mainText: this.showFullPlanName ? this.plan.productName : this.plan.productName.split('Plan')[1],
        planIndex: this === null || this === void 0 ? void 0 : this.planIndex
      },
      rightStack: {
        pillText: !!amount && _services.locale.localeString('Recommendation.DiscountText', {
          amount: amount
        }),
        show5g: true,
        showSecondPrice: true,
        mainText: {
          large: rightStackMainTextLarge,
          normal: rightStackMainTextNormal
        },
        showBottomText: mainPriceAfterDiscount.priceValue !== mainPriceBeforeDiscount.priceValue,
        bottomText: rightStackBottomTextNormal
      }
    };
  }
  get CardHeaderPropsWithDefault() {
    const priceAfterDiscount = this.getPriceByPriceType('commerceAdditionalPlanPrice');
    const priceBeforeDiscount = this.getPriceByPriceType('listAdditionalPlanPrice');
    const rightStackMainTextLarge = `${_services.locale.formatPrice(priceAfterDiscount.priceValue * this.numPlans)}`;
    const rightStackMainTextNormal = `/${_services.locale.localeString('Recommendation.month')}`;
    const rightStackMainTextPrefix = `${_services.locale.localeString('Recommendation.defaultPlanPrefix')} `;
    const rightStackBottomTextNormal = _services.locale.localeString('Recommendation.RightStackBottomTextTemplate', {
      amount: priceBeforeDiscount.durationAmount,
      unit: _services.locale.localeString('Recommendation.month'),
      price: _services.locale.formatPrice(priceBeforeDiscount.priceValue * this.numPlans),
      pluralUnit: _services.locale.localeString('Recommendation.Month')
    });
    const amount = Math.round(100 * (1 - priceAfterDiscount.priceValue / priceBeforeDiscount.priceValue));
    const moreThanOnePlan = this.numPlans > 1;
    return {
      leftStack: {
        topText: '',
        mainText: _services.locale.localeString('Recommendation.DefaultPlan.AdditionalPlans', {
          amount: this.numPlans
        }),
        planIndex: this.planIndex
      },
      rightStack: {
        pillText: !!amount && _services.locale.localeString('Recommendation.DiscountText', {
          amount: amount
        }),
        show5g: true,
        showSecondPrice: moreThanOnePlan,
        mainText: {
          large: rightStackMainTextPrefix + rightStackMainTextLarge,
          normal: rightStackMainTextNormal
        },
        bottomText: rightStackBottomTextNormal,
        showBottomText: true,
        blueText: `${_services.locale.formatPrice(priceAfterDiscount.priceValue)}` + 'c/' + _services.locale.localeString('Recommendation.plan')
      }
    };
  }
  get CardBodyProps() {
    return !this.isAdditionalPlan ? this.CardBodyPropsWithData : this.CardBodyPropsWithDefault;
  }
  get CardBodyPropsWithData() {
    const characteristics = this.plan.selectedVariant.characteristics.filter(characteristic => {
      return this.recommendationCharacteristics.find(recommendationCharacteristic => recommendationCharacteristic.key === characteristic.name && (characteristic === null || characteristic === void 0 ? void 0 : characteristic.title) && characteristic.valueText);
    }).sort((ch1, ch2) => {
      return this.recommendationCharacteristics.findIndex(recommendationCharacteristic => recommendationCharacteristic.key === ch1.name) - this.recommendationCharacteristics.findIndex(recommendationCharacteristic => recommendationCharacteristic.key === ch2.name);
    }).map(characteristic => {
      var _this$recommendationC, _this$recommendationC2, _this$recommendationC3, _this$recommendationC4;
      const icon = (_this$recommendationC = this.recommendationCharacteristics) === null || _this$recommendationC === void 0 ? void 0 : (_this$recommendationC2 = _this$recommendationC.find(recommendationCharacteristic => {
        return recommendationCharacteristic.key == characteristic.name;
      })) === null || _this$recommendationC2 === void 0 ? void 0 : _this$recommendationC2.icon;
      return {
        src: {
          sm: icon,
          md: icon,
          lg: icon
        },
        icon: (_this$recommendationC3 = this.recommendationCharacteristics) === null || _this$recommendationC3 === void 0 ? void 0 : (_this$recommendationC4 = _this$recommendationC3.find(recommendationCharacteristic => {
          return recommendationCharacteristic.key == characteristic.name;
        })) === null || _this$recommendationC4 === void 0 ? void 0 : _this$recommendationC4.icon,
        text: this.getCharacteristicTitle(characteristic),
        description: characteristic.description
      };
    });
    return {
      characteristics,
      planIndex: this === null || this === void 0 ? void 0 : this.planIndex
    };
  }
  get CardBodyPropsWithDefault() {
    const characteristics = this.recommendationCharacteristics.filter(characteristic => characteristic.title).map(characteristic => {
      return {
        src: {
          sm: characteristic.icon,
          md: characteristic.icon,
          lg: characteristic.icon
        },
        icon: characteristic.icon,
        text: this.getCharacteristicTitle({
          name: characteristic.key,
          title: characteristic.title,
          id: characteristic.key
        }),
        description: characteristic.description
      };
    });
    return {
      characteristics
    };
  }
  getPriceByPriceType(priceType) {
    var _this$plan2;
    return ((_this$plan2 = this.plan) === null || _this$plan2 === void 0 ? void 0 : _this$plan2.selectedVariant.price.find(price => {
      return price.priceType === priceType;
    })) || {};
  }
  formatLightText(lightText, text) {
    const pattern = new RegExp(`^(.*?)(${lightText})(.*)$`);
    return pattern.test(text) ? text.replace(pattern, '<bold>$1</bold>$2<bold>$3</bold>') : `<bold>${text}</bold>`;
  }
  getCharacteristicTitle(characteristic) {
    const configChar = characteristic.title ? _services.locale.localeString(`Recommendation.CollapsibleCharacteristics.${characteristic.name}`, {
      ...characteristic
    }) : `<bold>${characteristic.valueText}</bold>`;
    let text = configChar !== characteristic.name ? configChar : characteristic.title;
    if (characteristic.id === 'DATA_NATIONAL') {
      text = this.formatLightText('de navegación', text);
    } else if (characteristic.id === 'VOICE_ALLNET') {
      text = this.formatLightText('Habla hasta', text);
    }
    const boldRegex = /<bold>(.*?)<\/bold>/g;
    const parsedText = text.split(boldRegex).map((part, index) => {
      return /*#__PURE__*/_react.default.createElement(CharacteristicSpan, {
        bold: !!(index % 2),
        key: index
      }, part);
    });
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, parsedText);
  }
  get disclaimer() {
    return !this.isAdditionalPlan ? null : _services.locale.localeString('Recommendation.Disclaimer');
  }
}
exports.PlanCardParser = PlanCardParser;